<template>
  <section class="hero is-primary is-fullheight login-principal-container">
    <!-- Hero head: will stick at the top -->
    <div class="hero-head">
      <nav class="navbar">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" href="https://www.coconutcontrol.com/">
              <img src="@/assets/img/logo-final.png" />
            </a>
            <span class="navbar-burger burger" data-target="navbarMenuHeroA">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
          <div id="navbarMenuHeroA" class="navbar-menu">
            <div class="navbar-end"></div>
          </div>
        </div>
      </nav>
    </div>

    <!-- Hero content: will be in the middle -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-centered absolut-center">
          <div class="column is-half login-form-container">
            <p class="title" data-testid="login-title">¡Gracias por su pago!</p>
          </div>
          <div class="column is-half payment-message-container">
            Te damos la bienvenida a Coconut Control, es momento de tomar el
            control de tu empresa, recuerda que los primeros 3 meses son gratis,
            si tienes alguna duda o sugerencia no dudes en contactarnos.
          </div>
          <div class="column is-half payment-button">
            <b-button class="payment-button" @click="openHome()"
              >Empezar a usar Coconut Control</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Hero footer: will stick at the bottom -->
    <div class="hero-foot">
      <nav class="tabs">
        <div class="container">
          <ul>
            <li class="is-active"><a></a></li>
            <li><a>Punto de venta</a></li>
            <li><a>Control de inventario</a></li>
            <li><a>Venta de productos</a></li>
            <li><a>Administración de sucursales</a></li>
            <li><a>Control de pedidos</a></li>
          </ul>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
export default {
  name: "PaymentSuccess",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    async openHome() {
      // Confirm company payment method
      this.$store.commit("ACTIVATE_PAYMENT_METHOD");
      await this.$store.dispatch("GETCOMPANYINFORMATION");
      this.$router.push("/Dashboards/Initial").catch(() => {});
      let allPromises = [];

      allPromises.push(this.$store.dispatch("GETWAREHOUSESNOTRANSFERS"));
      allPromises.push(this.$store.dispatch("GETPRICESLISTS"));
      allPromises.push(this.$store.dispatch("GETARTICLES"));
      allPromises.push(this.$store.dispatch("GETARTICLESWAREHOUSESTOCK"));
      allPromises.push(this.$store.dispatch("GETPROVIDERS"));
      allPromises.push(
        this.$store.dispatch("GETPOSNOSALES", {
          warehouses: [],
        })
      );
      allPromises.push(this.$store.dispatch("GETCLIENTS"));
      allPromises.push(this.$store.dispatch("GETUSERS"));
      allPromises.push(this.$store.dispatch("GETEMPLOYEES"));
      allPromises.push(this.$store.dispatch("GETLASTEXPENSENUMBER"));
      allPromises.push(this.$store.dispatch("GETLASTWAREHOUSETRANSFERNUMBER"));
      allPromises.push(this.$store.dispatch("GETCOMPANYEMAILS"));
      allPromises.push(this.$store.dispatch("GETLASTPAYMENTNUMBER"));
      allPromises.push(this.$store.dispatch("GETLASTSALENUMBER"));
      allPromises.push(this.$store.dispatch("GETUSERNOTIFICATIONS"));
      allPromises.push(this.$store.dispatch("GETCATEGORIES"));
      allPromises.push(this.$store.dispatch("GETALLSCATEGORIES"));

      Promise.all(allPromises);
    },
  },
};
</script>

<style scoped>
@import "../style/Login.css";
@import "../style/Global.css";
</style>
